import { SeatPicker } from "./SeatPicker";
import { PitPicker } from "./PitPicker";

export class PickerEditionMode {
    constructor(props) {
        this.seatPicker = new SeatPicker(props);
        this.pitPicker = new PitPicker(props);
    }

    destroy() {
        this.seatPicker.destroy();
        this.pitPicker.destroy();
    }
}